export const orderStatus = ["NEW", "CANCELLED", "FILLED"];
